import React from 'react'

export default function Button({ children, onClick, style }) {
  return (
    <button style={style} className="button-modal" onClick={onClick}>
      {children}
    </button>
  )
}
